import Vue from 'vue'
import axios from 'axios'


Vue.use({
    install() {
        Vue.prototype.$login = function (slug) {
            slug = (slug == undefined || slug ==""  )? "desporto" : slug
            // Submit the form.
            axios.post(`${config.appUrl}/api/login`,{redirectTo: slug}).then(function(response){
                window.location.href = response.data;

            })
            // this.$store.dispatch('local/set', { key: 'login', value: true })
            // this.$store.dispatch('local/set', { key: 'redirect-route', value: slug })
        }
    }
})


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/login.js